import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/Modal/GenericModal'
import TextField from 'component/TextField'

const EditModal = ({ closeModal, submit, translate, value }) => {
  const [editValue, setEditValue] = useState(value.dsJustification)

  function SubmitEditedItem() {
    const newValue = {
      ...value,
      dsJustification: editValue,
    }
    submit(newValue)
  }

  function clearField() {
    setEditValue('')
  }

  return (
    <Modal
      buttonClass='half-w'
      cancelButtonText={translate('button.cancel')}
      center={false}
      confirmButtonText={translate('save_button_label')}
      isConfirmButtonDisabled={
        editValue.length < 1 ||
        editValue === value.dsJustification ||
        editValue.trim().length < 1
      }
      isOpen
      onCloseModal={closeModal}
      onConfirm={() => SubmitEditedItem()}
      size='md'
      className='edit-modal-demarcate'
      title={translate('justifications.justificationEdit')}
    >
      <div className='edit-justification-modal'>
        <div className='w-100'>
          <TextField
            className='form-control no-change-color'
            fill
            maxLength={50}
            label={translate('justifications.justificationDesc')}
            onChange={(event) => {
              setEditValue(event.target.value)
            }}
            placeholder={translate(
              'demarcate.justifies.editModal.textField.placeholder'
            )}
            required
            value={editValue}
            onRightIconClick={() => clearField()}
            rightIcon={'glyph glyph-x'}
          />
        </div>
      </div>
    </Modal>
  )
}

EditModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  value: PropTypes.object.isRequired,
}

export default EditModal
